import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';

import { gettext } from '@eb/i18n';
import { EMPTY_STATES_PROP_TYPE } from '../constants/propTypes';

import CalendarSVG from 'eventbrite_design_system/iconography/icons/Calendar';

import StateMessage from './StateMessage';

const USE_DEFAULT_EMPTY_STATE = {
    title: gettext('No events in your area'),
    iconType: <CalendarSVG />,
    iconSize: 'medium',
    description: gettext('Try a different location'),
    primaryLink: '',
    primaryText: '',
};

export default class EmptyState extends PureComponent {
    static propTypes = {
        emptyState: EMPTY_STATES_PROP_TYPE,
        bucketKey: PropTypes.string,
        shouldShowEmptyState: PropTypes.bool,
        isAuthenticated: PropTypes.bool,
    };

    _getEmptyStateComponent = ({
        bucketKey,
        title,
        iconType,
        iconSize,
        description,
        primaryLink,
        primaryText,
    }) => (
        <>
            <div
                className="feed-events__empty-state"
                key={bucketKey}
                id={`feed-events__empty-state-${bucketKey}`}
            >
                <StateMessage
                    key={`empty-state-${bucketKey}-isAuth`}
                    title={title}
                    iconType={iconType}
                    iconSize={iconSize}
                    description={description}
                    primaryLink={primaryLink}
                    primaryText={primaryText}
                />
            </div>
        </>
    );

    render() {
        const { emptyState, bucketKey, isAuthenticated } = this.props;

        // Default behavior is don't show any bucket
        let emptyStateComponent = null;

        // Get the first valid condition for empty state
        const validEmptyState = find(
            emptyState,
            (es) =>
                es.validation.shouldShowEmptyState &&
                (es.validation.isAuthenticated === isAuthenticated ||
                    es.validation.useDefault === true),
        );

        // If we don't have a valid condition is because we don't have to render any bucket
        if (!isEmpty(validEmptyState)) {
            let emptyStateConfig = USE_DEFAULT_EMPTY_STATE;

            // If we have a config, we overwrite default empty state
            if (!isEmpty(validEmptyState.config)) {
                emptyStateConfig = validEmptyState.config;
            }
            emptyStateComponent = this._getEmptyStateComponent({
                bucketKey,
                ...emptyStateConfig,
            });
        }

        return emptyStateComponent;
    }
}
